import addPanelDataConsts from '@/addPanelDataConsts';
import type { EditorAPI } from '@/editorAPI';
import calendarWidgetConsts from './calendarWidgetConsts';
import editorActionsService from '../../common/editorActionsService';
import experiments from 'experiment';

export default function ({ editorAPI }: { editorAPI: EditorAPI }) {
  const isWixStudio = experiments.isOpen(
    'specs.responsive-editor.BookingsChangeImagesOnAddPanel',
  );
  const actionsService = editorActionsService({ editorAPI });
  const addPanelConsts = addPanelDataConsts;

  const calendarWidget = {
    id: calendarWidgetConsts.CALENDAR_PRESET_KEY,
    structure: {
      layout: {
        width: 980,
        height: 700,
        scale: 1,
        rotationInDegrees: 0,
        fixedPosition: false,
      },
      componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
      data: {
        type: 'TPAWidget',
        metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
        applicationId: '2269',
        tpaData: {
          type: 'TPAData',
          metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
          content: `{"presetId":"${calendarWidgetConsts.CALENDAR_PRESET_KEY}"}`,
        },
        widgetId: calendarWidgetConsts.CALENDAR_WIDGET_ID,
      },
      style: {
        type: 'TopLevelStyle',
        metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false },
        style: {
          properties: {},
          propertiesSource: {},
          groups: {},
        },
        componentClassName: 'wysiwyg.viewer.components.tpapps.TPAWidget',
        pageId: '',
        compId: '',
        styleType: 'custom',
        skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
      },
    },
    preset: {
      rect: isWixStudio
        ? { width: 324, height: 205, x: 0, y: 0 }
        : { width: 304, height: 171, x: 10, y: 10 },
      label: '',
      tags: null as any,
    },
  };

  const calendarWidgetItems = [calendarWidget];

  return {
    id: 'wixBookingsCalendarWidget',
    type: addPanelConsts.SECTIONS_TYPES.PRESET,
    hide: false,
    title: calendarWidgetConsts.CALENDAR_TITLE_KEY,
    subNavigationTitle: calendarWidgetConsts.CALENDAR_TITLE_KEY,
    presetTitle: calendarWidgetConsts.CALENDAR_TITLE_KEY,
    tooltipTitle: calendarWidgetConsts.CALENDAR_TOOLTIP_TITLE_KEY,
    tooltipDescription: calendarWidgetConsts.CALENDAR_TOOLTIP_DESCRIPTION_KEY,
    showSectionHeader: true,
    additionalBehaviours: {
      labelMode: addPanelConsts.LABEL_BEHAVIOUR.ALWAYS,
      infoIcon: addPanelConsts.INFO_ICON_BEHAVIOUR.NONE,
      hoverImageAction: addPanelConsts.HOVER_IMAGE_ACTIONS.NONE,
      scaleProportion: addPanelConsts.DEFAULT_SCALE_FOR_PRESET,
      iconEnabledForComps: [] as AnyFixMe,
    },
    props: {
      image: isWixStudio
        ? calendarWidgetConsts.CALENDAR_WIDGET_IMAGE_WIX_STUDIO
        : calendarWidgetConsts.CALENDAR_WIDGET_IMAGE,
      imageHover: null as AnyFixMe,
      onDrop: actionsService.onRefWidgetDrop,
      items: calendarWidgetItems,
      compTypes: ['wysiwyg.viewer.components.tpapps.TPAWidget'],
    },
    onClick: actionsService.onRefWidgetClick,
  };
}
